<form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">
  @if (showCurrentPassword) {
    <div class="password-input-container">
      <label data-translation-key="reset_password_current_password">
        {{ 'reset_password.current_password' | translate }}
        <span class="required">*</span>
      </label>
      <div class="password-input-wrapper">
        <input
          [type]="showCurrent ? 'text' : 'password'"
          class="form-control input-field"
          formControlName="current_password"
          [placeholder]="'reset_password.current_password_placeholder' | translate"
        [ngClass]="{
          'is-invalid':
            (passwordForm.get('current_password')?.errors &&
              passwordForm.get('current_password')?.touched) ||
            passwordForm.get('current_password')?.errors?.serverError
        }"
          data-translation-key="reset_password_current_password_placeholder"
          />
          <button
            type="button"
            class="toggle-password input-action"
            (click)="togglePasswordVisibility('currentPassword')"
            >
            <i class="bi" [ngClass]="showCurrent ? 'bi-eye-slash' : 'bi-eye'"></i>
          </button>
        </div>
        @if (
          passwordForm.get('current_password')?.touched &&
          passwordForm.get('current_password')?.invalid
          ) {
          <mat-error
            >
            @if (passwordForm.get('current_password')?.errors?.required) {
              <span
                data-translation-key="reset_password_current_password_required"
                >
                {{ 'reset_password.current_password_required' | translate }}
              </span>
            }
            @if (passwordForm.get('current_password')?.errors?.serverError) {
              <span>
                {{ passwordForm.get("current_password")?.errors?.serverError }}
              </span>
            }
          </mat-error>
        }
      </div>
    }
    <div class="password-input-container">
      <label
      [attr.data-translation-key]="
        formType == 'change'
          ? 'reset_password_new_password'
          : 'reset_password_password'
      "
        >{{
        formType == "change"
        ? ('reset_password.new_password' | translate)
        : ('reset_password.password' | translate)
        }}
        <span class="required">*</span></label
        >
        <div class="password-input-wrapper">
          <input
            #passwordInput
            [type]="showPassword ? 'text' : 'password'"
            class="form-control input-field"
            formControlName="password"
        [placeholder]="
          formType == 'change'
            ? ('reset_password.new_password_placeholder' | translate)
            : ('reset_password.password' | translate)
        "
        [ngClass]="{
          'is-invalid':
            (passwordForm.get('password')?.errors &&
              passwordForm.get('password')?.touched) ||
            passwordForm.get('password')?.errors?.serverError
        }"
        [attr.data-translation-key]="
          formType == 'change'
            ? 'reset_password_new_password_placeholder'
            : 'reset_password_password'
        "
            />
            <button
              type="button"
              class="toggle-password input-action"
              (click)="togglePasswordVisibility('password')"
              >
              <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
            </button>
          </div>
          @if (
            passwordForm.get('password')?.touched &&
            passwordForm.get('password')?.invalid
            ) {
            <mat-error
              >
              @if (passwordForm.get('password')?.invalid) {
                <span
                  data-translation-key="buyer_register_password_validation"
                  >
                  {{ 'buyer_register.password_validation' | translate }}
                </span>
              }
              @if (passwordForm.get('password')?.errors?.serverError) {
                <span>
                  {{ passwordForm.get("password")?.errors?.serverError }}
                </span>
              }
            </mat-error>
          }
          <div class="password-strength-meter">
            <span
              class="strength-segment"
              [ngClass]="{ active: passwordStrength >= 1 }"
            ></span>
            <span
              class="strength-segment"
              [ngClass]="{ active: passwordStrength >= 2 }"
            ></span>
            <span
              class="strength-segment"
              [ngClass]="{ active: passwordStrength >= 3 }"
            ></span>
            <span
              class="strength-segment"
              [ngClass]="{ active: passwordStrength >= 4 }"
            ></span>
          </div>
          <div
            class="password-strength-text"
            [attr.data-translation-key]="getPasswordStrengthData().translationKey"
            >
            {{ 'reset_password.password_strength' | translate }}:

            {{ getPasswordStrengthData().text }}
          </div>
        </div>

        <div class="password-input-container">
          <label data-translation-key="reset_password_confirm_password"
            >{{ 'reset_password.confirm_password' | translate }}
            <span class="required">*</span></label
            >
            <div class="password-input-wrapper">
              <input
                [type]="showConfirmPassword ? 'text' : 'password'"
                class="form-control input-field"
                formControlName="password_confirmation"
                [placeholder]="'reset_password.confirm_password' | translate"
        [ngClass]="{
          'is-invalid':
            passwordMatch === false ||
            passwordForm.get('password_confirmation')?.errors?.serverError
        }"
                data-translation-key="reset_password_confirm_password"
                />
                <button
                  type="button"
                  class="toggle-password input-action"
                  (click)="togglePasswordVisibility('confirmPassword')"
                  >
                  <i
                    class="bi"
                    [ngClass]="showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'"
                  ></i>
                </button>
              </div>
              @if (passwordMatch === false) {
                <div
                  class="input-feedback error"
                  data-translation-key="reset_password_passwords_do_not_match"
                  >
                  {{ 'reset_password.passwords_do_not_match' | translate }}
                </div>
              }
              @if (passwordForm.get('password_confirmation')?.errors?.serverError) {
                <div>
                  {{ passwordForm.get("password_confirmation")?.errors?.serverError }}
                </div>
              }
            </div>

            @if (showTermsCheckbox) {
              <div class="input-container">
                <div class="custom-checkbox">
                  <input
                    class="custom-control-input"
                    type="checkbox"
                    id="terms-agree"
                    formControlName="accept_terms"
        [ngClass]="{
          'is-invalid':
            passwordForm.get('accept_terms')?.invalid &&
            passwordForm.get('accept_terms')?.touched
        }"
                    />
                    <label for="terms-agree" class="custom-control-label">
                      <span data-translation-key="buyer_register_accept_terms_message">{{ 'buyer_register.accept_terms_message' | translate }}</span>
                      <a
                        [href]="urlFront + '/terms-of-use'"
                        target="_blank"
                        data-translation-key="buyer_register_terms_conditions"
                        >
                        {{ 'buyer_register.terms_conditions' | translate }}</a
                        >
                        <span data-translation-key="buyer_register_and">
                          {{ 'buyer_register.and' | translate }}</span
                          >
                          <a
                            [href]="urlFront + '/privacy'"
                            target="_blank"
                            data-translation-key="buyer_register_privacy_policy"
                            >{{ 'buyer_register.privacy_policy' | translate }}</a
                            >
                            <span data-translation-key="buyer_register_of_this_website">{{ 'buyer_register.of_this_website' | translate }}</span
                              >.
                            </label>
                          </div>
                          @if (
                            (passwordForm.get('accept_terms')?.invalid &&
                            passwordForm.get('accept_terms')?.touched) ||
                            !passwordForm.get('accept_terms')?.value
                            ) {
                            <div
                              class="input-feedback error"
                              data-translation-key="buyer_register_you_must_accept_terms"
                              >
                              {{ 'buyer_register.you_must_accept_terms' | translate }}
                            </div>
                          }
                        </div>
                      }

                      <div class="password-requirements">
                        <h5 data-translation-key="reset_password_password_requirements">
                          {{ 'reset_password.password_requirements' | translate }}
                        </h5>
                        <ul>
                          <li
                            [ngClass]="{ 'requirement-met': requirements.length }"
                            data-translation-key="reset_password_at_least_8_characters"
                            >
                            <i
                              class="bi"
          [ngClass]="
            requirements.length ? 'bi-check-circle-fill' : 'bi-check-circle'
          "
                            ></i>
                            {{ 'reset_password.at_leas_8_characters' | translate }}
                          </li>
                          <li
                            [ngClass]="{ 'requirement-met': requirements.uppercase }"
                            data-translation-key="reset_password_at_least_one_uppercase_letter"
                            >
                            <i
                              class="bi"
          [ngClass]="
            requirements.uppercase ? 'bi-check-circle-fill' : 'bi-check-circle'
          "
                            ></i>
                            {{ 'reset_password.at_least_one_uppercase_letter' | translate }}
                          </li>
                          <li
                            [ngClass]="{ 'requirement-met': requirements.lowercase }"
                            data-translation-key="reset_password_at_least_one_lowercase_letter"
                            >
                            <i
                              class="bi"
          [ngClass]="
            requirements.lowercase ? 'bi-check-circle-fill' : 'bi-check-circle'
          "
                            ></i>
                            {{ 'reset_password.at_least_one_lowercase_letter' | translate }}
                          </li>
                          <li
                            [ngClass]="{ 'requirement-met': requirements.number }"
                            data-translation-key="reset_password_at_least_one_number"
                            >
                            <i
                              class="bi"
          [ngClass]="
            requirements.number ? 'bi-check-circle-fill' : 'bi-check-circle'
          "
                            ></i>
                            {{ 'reset_password.at_least_one_number' | translate }}
                          </li>
                          <li
                            [ngClass]="{ 'requirement-met': requirements.special }"
                            data-translation-key="reset_password_at_least_one_special_character"
                            >
                            <i
                              class="bi"
          [ngClass]="
            requirements.special ? 'bi-check-circle-fill' : 'bi-check-circle'
          "
                            ></i>
                            {{ 'reset_password.at_least_one_special_character' | translate }}
                          </li>
                        </ul>
                      </div>

                      <div class="form-buttons justify-content-end">
                        <!-- <button type="button" class="btn btn-secondary" (click)="back()">
                        <i class="bi bi-arrow-left"></i>
                        Back
                      </button> -->
                      <button
                        type="submit"
                        class="btn btn-primary"
                        [disabled]="passwordForm.invalid || !passwordMatch || isLoading"
                        >
                        @if (!isLoading) {
                          <span>
                            @if (formType == 'change') {
                              <span
                                data-translation-key="reset_password_update_password"
                                >
                                {{ 'reset_password.update_password' | translate }}
                                <i class="bi bi-check-circle"></i>
                              </span>
                            } @else {
                              <span data-translation-key="reset_password_submit"
                                >{{ 'reset_password.submit' | translate }}
                                <i class="bi bi-check-lg icon-right"></i>
                              </span>
                            }
                          </span>
                        } @else {
                          <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          <span class="ms-2" data-translation-key="reset_password_processing">{{ 'reset_password.processing' | translate }}</span>
                        }
                      </button>
                    </div>
                  </form>
